import loadable from "@loadable/component";

export const SearchBar = loadable(
  () => import(/* webpackChunkName: "client-ui" */"./search/search-bar"),
  { ssr: false }
);

export const ProtectedOutlet = loadable(
  () => import(/* webpackChunkName: "client-ui" */"./protected-outlet"),
  { ssr: false }
);

export const getRecaptchaToken = (siteKey: string, opt?: { action?: string }) =>
  new Promise((resolve, reject) => {
    window.grecaptcha.ready(() => {
      window.grecaptcha
            .execute(siteKey, opt)
            .then(resolve)
            .catch(reject);
    });
  });
